import { Injectable } from '@angular/core';
import * as Rx from "rxjs/Rx";
import Swal from 'sweetalert2';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable({
  providedIn: 'root'
})

export class WebsocketService {

  constructor() { }
  public ping;
  public reConnectCount:number = 5;
  public counter:number = 0
  public reConnect;
  public isOpen: BehaviorSubject<Boolean> = new BehaviorSubject<Boolean>(false);
  public status:BehaviorSubject<any> = new BehaviorSubject<any>("");
  private subject: Rx.Subject<any>;
  private ws:WebSocket; 
  public connect(url): Rx.Subject<MessageEvent> {
    console.log('this.subject', this.subject);
    if (!this.subject) {
      this.subject = this.create(url);
      console.log("Successfully connected: " + url);
      if(!localStorage.getItem("counter")){
        localStorage.setItem('counter',`${this.counter}`);
      }
      this.ping = setInterval(()=>{
        console.log("ping....")
        this.ws.send(JSON.stringify({
          type:'ping',body:"ping",action:"sendmessage"})
        )},50000);
      this.reConnect = setInterval(()=>{
        if(this.ws.readyState === WebSocket.CLOSED){
          this.counter = JSON.parse(localStorage.getItem('counter'));
          localStorage.setItem('counter',`${++this.counter}`);
       }
       if(this.counter === this.reConnectCount){
         localStorage.setItem('counter','0');         
         clearInterval(this.reConnect);
         const Toast = Swal.mixin({
          toast: true,
          position: 'top',
          showConfirmButton: false
        });
         Toast.fire({
          type: 'warning',
          title: 'Something went wrong.You are disconnected from chat!!!'
        });
        }
        else{
          this.checkForConnection();
        }
      },5000);
     
    }
    return this.subject;
  }

  private create(url): Rx.Subject<MessageEvent> {
    this.ws= new WebSocket(url);
    let observable = Rx.Observable.create((obs: Rx.Observer<MessageEvent>) => {
      this.ws.onmessage = obs.next.bind(obs);
      this.ws.onerror = obs.error.bind(obs);
      this.ws.onopen = ()=>{this.isOpen.next(true);
      };
      this.ws.onclose = obs.complete.bind(obs);
      return this.ws.close.bind(this.ws);
    });
    let observer = {
      next: (data: Object) => {
        if (this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify(data));
        }
      },
      complete: (data:any)=>{
        this.subject=null
        this.status.next("DISCONNECTED");
      }
    };
    return Rx.Subject.create(observer, observable);
  }

  public disconnect() {
    if(this.ws && this.ws.readyState===WebSocket.OPEN){
    console.log("websocket disconnected....")
    clearInterval(this.ping);
    clearInterval(this.reConnect);
    this.ws.close();
    this.subject.complete(); 
  }
  }

  public sendMessage(data) {
    console.log("Inside websocket service ", data);
    this.subject.next(data);
  }

  public checkForConnection(){
    if(this.ws && this.ws.readyState === WebSocket.OPEN){
      if(this.status.value === "DISCONNECTED"){
      this.status.next("CONNECTED");
    }
      console.log("Stable Connection...");
    }
    else if(localStorage.getItem('uid') && this.ws.readyState === WebSocket.CLOSED){
      this.status.next("DISCONNECTED");
      clearInterval(this.reConnect);
      const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false
      });
      Toast.fire({
        type: 'warning',
        title: 'You are disconnected from chat!!!'
      });
      this.counter = JSON.parse(localStorage.getItem("counter"))
      location.reload();
    }
  }

}
